export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8059.5f4d9e99.jpg";